import CloseIcon from "@mui/icons-material/Close";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
//import { TransitionProps } from "@mui/material/transitions";
import * as React from "react";
import ListItem from "@mui/material/ListItem";
import { Link } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import axios from "axios";
import "./UserModal.css";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog() {
  const [open, setOpen] = React.useState(false);
  const [formData, setFormData] = React.useState({
    name: "",
    email: "",
    place: "",
    plantName: "",
    scientificName: "",
    category: "", // Updated to have initial empty value
    information: "",
    image: null,
    imagePreview: null,
    emailError: "",
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setFormData({
      ...formData,
      image: file,
      imagePreview: URL.createObjectURL(file),
    });
  };

  const handleSubmit = async () => {
    // Validate email format
    const isValidEmail = validateEmail(formData.email);
    if (!isValidEmail) {
      setFormData({ ...formData, emailError: "Invalid email format" });
      return;
    }

    // Clear email error message
    setFormData({ ...formData, emailError: "" });

    try {
      const formDataToUpload = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToUpload.append(key, value);
      });

      await axios.post("https://server-zqk9.onrender.com/upload", formDataToUpload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
alert('Form submitted successfully');

resetForm();
    }catch (error) {
      console.error("Error submitting form:", error);
      alert(
        "issue is " + (error.response ? error.response.data : "Unknown error")
      );
    }
  };

  const handleClose = () => {
    resetForm();
    setOpen(false);
  };

  const handleUploadButtonClick = () => {
    // Programmatically click the hidden file input
    document.getElementById("image-upload").click();
  };

  const resetForm = () => {
    setFormData({
      name: "",
      email: "",
      place: "",
      plantName: "",
      scientificName: "",
      category: "",
      information: "",
      image: null,
      imagePreview: null,
      emailError: "",
    });
  };

  // Email validation function
  const validateEmail = (email) => {
    // Regular expression for email validation
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  return (
    <React.Fragment>
      <Link
        variant="outlined"
        onClick={handleClickOpen}
        style={{ color: "#fff", textDecoration: "none" }}
      >
        <FaPlus />
      </Link>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        sx={{ zIndex: 9999, backgroundColor: "honeydew" }}
      >
        <AppBar
          sx={{
            position: "relative",
            backgroundColor: "#042705",
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon style={{ fontSize: "20px", fontWeight: "bold" }} />
            </IconButton>
            <Typography
              sx={{ ml: 2, flex: 1 }}
              variant="h6"
              component="div"
              style={{
                fontWeight: "600",
                fontSize: "20px",
                marginLeft: "0%",
                fontFamily: "Fredoka, sans-serif",
              }}
            >
              Plant Information
            </Typography>
            <Button
              autoFocus
              color="inherit"
              onClick={handleSubmit}
              style={{ fontWeight: "600", fontSize: "19px" }}
            >
              Save
            </Button>
          </Toolbar>
        </AppBar>
        <div className="container py-3">
          <h1 style={{ fontWeight: "500", fontSize: "22px" }}>
            <u>Fill Details</u>
          </h1>
          <p style={{ fontWeight: "500", fontSize: "17px" }}>
            Fill all the fields, your information will be verified by the team.
          </p>

          <div className="row">
            <div className="col-md-5">
              <List>
                <ListItem>
                  <TextField
                    label="Name"
                    variant="outlined"
                    fullWidth
                    onChange={handleChange("name")}
                    value={formData.name}
                    
                  />
                </ListItem>
                <ListItem>
                  <TextField
                    label="Email"
                    variant="outlined"
                    fullWidth
                    onChange={handleChange("email")}
                    value={formData.email}
                    error={!!formData.emailError} // Apply error styling if emailError exists
                    helperText={formData.emailError} // Show error message
                    required
                  />
                </ListItem>
                <ListItem>
                  <TextField
                    label="Place"
                    variant="outlined"
                    fullWidth
                    onChange={handleChange("place")}
                    value={formData.place}
                    
                  />
                </ListItem>
                <ListItem>
                  <TextField
                    label="Plant Name"
                    variant="outlined"
                    fullWidth
                    onChange={handleChange("plantName")}
                    value={formData.plantName}
                    required
                  />
                </ListItem>
                <ListItem>
                  <TextField
                    label="Scientific Name"
                    variant="outlined"
                    fullWidth
                    onChange={handleChange("scientificName")}
                    value={formData.scientificName}
                    
                  />
                </ListItem>
                <ListItem>
                  <select
                    id="category"
                    value={formData.category}
                    onChange={handleChange("category")}
                    placeholder="Select category"
                    fullWidth
                    style={{
                      width: "100%",
                      height: "50px",
                      padding: "10px",
                      borderRadius: "4px",
                      border: "1px solid #ced4da",
                    }}
                  >
                    <option value="" disabled selected hidden>
                      Select Category
                    </option>
                    <option value="Herb">Herbs</option>
                    <option value="Shrub">Shrubs</option>
                    <option value="Tree">Trees</option>
                  </select>
                </ListItem>
              </List>
            </div>
            <div className="col-md-5">
              <List>
                <ListItem>
                  <TextField
                    label="Information"
                    variant="outlined"
                    multiline
                    rows={4}
                    fullWidth
                    onChange={handleChange("information")}
                    value={formData.information}
                  
                  />
                </ListItem>
              </List>
              <List>
                <ListItem>
                  <input
                    type="file"
                    accept="image/*"
                    id="image-upload"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                    required
                  />
                  <label htmlFor="image-upload">
                    <Button
                      variant="outlined"
                      component="span"
                      onClick={handleUploadButtonClick}
                    >
                      Upload Image
                    </Button>
                  </label>
                  {formData.image && (
                    <div>
                      <img
                        src={formData.imagePreview}
                        alt=""
                        style={{
                          maxWidth: "100%",
                          maxHeight: "200px",
                          marginTop: "10px",
                        }}
                      />
                    </div>
                  )}
                </ListItem>
              </List>
            </div>
          </div>
        </div>
      </Dialog>
    </React.Fragment>
  );
}
